/*global translate*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Jsx from './poll_list.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const {rxaget} = global.rootRequire('classes/ulti')
const chatDB = global.rootRequire('classes/indexedDB').default
class RxPollList_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      group_id : this.props.group_id,
      polls:[],
      group:rxaget(this.props, 'rxgroup.group', {})
      
    }
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
  }
  componentDidMount(){
    this.fetchPollList()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(this.props.rxChangePolls.status !==  nextProps.rxChangePolls.status){
      this.updatePolls(this.state.group_id)
    }
  }

  async updatePolls(group_id){
    let polls = await chatDB.polls.get(group_id.toString())
    this.setState({polls:polls.data})
  }

  fetchPollList(){
    let group_id = this.state.group_id
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.props.token }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_list')+'?group_id='+group_id, {
      method: 'GET',
      body: null,
      headers: headers 
    })
    .then((res) => { return res.json() })
    .then((json) => {
      if(json && json.polls){
        this.setState({polls:json.polls})
      }
    }).catch(er => console.log(er))
  }

  createPollClick(){
    let pollInfo = {}
    this.sendPollDataToFooter(pollInfo, 'createPollClick')
  }

  sendPollDataToFooter(pollInfo, typeAction) {
    let elem = document.getElementById('chat-value')
    elem.dispatchEvent(new CustomEvent('chooseOption', {
      detail: {
        pollInfo: pollInfo,
        type: typeAction
      }
    }))
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  rxgroup: state.rxgroup,
  netaauth: state.netaauth,
  rxChangePolls:state.rxChangePolls,
})

const mapDispatchToProps = {

}

const RxPollList = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxPollList_)

export default RxPollList

